var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var HotelTouristRecommendations = function () {
            function HotelTouristRecommendations(recommendations) {
                _classCallCheck(this, HotelTouristRecommendations);

                this.recommendations = recommendations || [];
                this.modal = null;
                this.pageSize = 3;
                this.wrapper = document.querySelector('.hotel-tourist-recommendations__wrapper');
                this.loadMoreButton = document.querySelector('.hotel-tourist-recommendations__load-more');

                this.initModal();
                this.syncLoadMoreButton();
                this.handlers();
            }

            _createClass(HotelTouristRecommendations, [{
                key: "initModal",
                value: function initModal() {
                    this.modal = new MobileModal({
                        theme: 'theme-full',
                        typeContent: 'content',
                        detachContentId: 'full-recommendation',
                        title: 'Советы от других туристов'
                    });
                }
            }, {
                key: "renderModalContent",
                value: function renderModalContent(index) {
                    var _this = this;

                    var contentHtml = "<div class=\"hotel-tourist-recommendations-list\">";

                    this.recommendations.forEach(function (recommendation) {
                        var isActive = recommendation.id == index;
                        var author = _this.escapeHtml(recommendation.author || '');
                        var date = _this.escapeHtml(recommendation.date || '');
                        var text = recommendation.text || '';

                        contentHtml += "\n                <div class=\"hotel-tourist-recommendation-in-modal " + (isActive ? 'active' : '') + "\" id=\"recommendation-" + recommendation.id + "\">\n                    <div class=\"hotel-tourist-recommendations__author-date\">\n                        " + author + ": \u043E\u0442\u0434\u044B\u0445\u0430\u043B(\u0430) \u0432 " + date + "\n                    </div>\n                    <div class=\"hotel-tourist-recommendations__text\">\n                        " + text + "\n                    </div>\n                </div>\n            ";
                    });

                    contentHtml += "</div>";

                    this.modal.content = contentHtml;
                    this.modal.showModal();

                    // Прокручиваем к выбранной рекомендации
                    this.scrollToRecommendation(index);
                }
            }, {
                key: "scrollToRecommendation",
                value: function scrollToRecommendation(index) {
                    setTimeout(function () {
                        var selectedElement = document.getElementById("recommendation-" + index);
                        if (selectedElement) {
                            selectedElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }, 100);
                }
            }, {
                key: "handlers",
                value: function handlers() {
                    var _this2 = this;

                    if (typeof eventDispatcher !== 'undefined') {
                        eventDispatcher.on('click', '.hotel-tourist-recommendations__load-more', function (event, element) {
                            event.preventDefault();
                            _this2.showMoreRecommendations();
                        });
                        eventDispatcher.on('click', '.js-open-recommendations-modal', function (event, element) {
                            event.preventDefault();
                            var index = element.dataset.index;
                            if (index) {
                                _this2.renderModalContent(index);
                            }
                        });

                        return;
                    }

                    document.addEventListener('click', function (event) {
                        var loadMoreButton = event.target.closest('.hotel-tourist-recommendations__load-more');
                        if (loadMoreButton) {
                            event.preventDefault();
                            _this2.showMoreRecommendations();
                            return;
                        }

                        var recommendationButton = event.target.closest('.show-full-tourist-recommendation, .js-open-recommendations-modal');
                        if (!recommendationButton) {
                            return;
                        }

                        event.preventDefault();
                        var index = recommendationButton.dataset.index;
                        if (index) {
                            _this2.renderModalContent(index);
                        }
                    });
                }
            }, {
                key: "showMoreRecommendations",
                value: function showMoreRecommendations() {
                    var hiddenItems = this.getHiddenRecommendations();
                    hiddenItems.slice(0, this.pageSize).forEach(function (item) {
                        item.classList.remove('is-hidden');
                    });

                    this.syncLoadMoreButton();
                }
            }, {
                key: "getHiddenRecommendations",
                value: function getHiddenRecommendations() {
                    if (!this.wrapper) {
                        return [];
                    }

                    return Array.from(this.wrapper.querySelectorAll('.hotel-tourist-recommendations__item.is-hidden'));
                }
            }, {
                key: "syncLoadMoreButton",
                value: function syncLoadMoreButton() {
                    if (!this.loadMoreButton) {
                        return;
                    }

                    this.loadMoreButton.hidden = this.getHiddenRecommendations().length === 0;
                }
            }, {
                key: "escapeHtml",
                value: function escapeHtml(text) {
                    var div = document.createElement('div');
                    div.textContent = text;
                    return div.innerHTML;
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    if (this.modal) {
                        // Закрываем модальное окно если есть такой метод
                        if (typeof this.modal.hideModal === 'function') {
                            this.modal.hideModal();
                        }
                    }
                }
            }]);

            return HotelTouristRecommendations;
        }();

        window.HotelTouristRecommendations = HotelTouristRecommendations;
    }, {}] }, {}, [1]);